(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider) {
        $stateProvider
            .state('market-price', {
                parent: 'app',
                url: '/market-price?page&sort&search',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.marketPrice.home.title',
                    title: 'Market Prices'
                },
                views: {
                    'market-price@': {
                        templateUrl: 'app/entities/market-price/market-price.html',
                        controller: 'MarketPriceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketPrice');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('market-price-detail', {
                parent: 'app',
                url: '/market-price/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.marketPrice.detail.title',
                    title: 'Detail'
                },
                views: {
                    'market-price-detail@': {
                        templateUrl: 'app/entities/market-price/market-price-detail.html',
                        controller: 'MarketPriceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketPrice');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MarketPrice', function($stateParams, MarketPrice) {
                        return MarketPrice.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'market-price',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('market-price-detail.edit', {
                parent: 'app',
                url: '/market-price/detail/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/market-price/market-price-dialog.html',
                        controller: 'MarketPriceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MarketPrice', function(MarketPrice) {
                                return MarketPrice.get({id : $stateParams.id}).$promise;
                            }],
                            translatePartialLoader:['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('marketPrice');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('market-price.new', {
                parent: 'app',
                url: '/market-price/new',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/market-price/market-price-dialog.html',
                        controller: 'MarketPriceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    createdOn: new Date(),
                                    createdBy: 'admin',
                                    modifiedOn: new Date(),
                                    modifiedBy: 'admin',
                                    month: 'MAR',
                                    year: new Date().getFullYear(),
                                    price: null,
                                    priceType: 'CTS',
                                    wtUnitType: 'LB',
                                    priceDisplay: null
                                };
                            },
                            translatePartialLoader:['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('marketPrice');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('market-price', null, { reload: 'market-price' });
                    }, function() {
                        $state.go('market-price');
                    });
                }]
            })
            .state('market-price.edit', {
                parent: 'app',
                url: '/market-price/{id}/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/market-price/market-price-dialog.html',
                        controller: 'MarketPriceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MarketPrice', function(MarketPrice) {
                                return MarketPrice.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('market-price', null, { reload: 'market-price' });
                    }, function() {
                        $state.go('market-price');
                    });
                }]
            })
            .state('market-price.delete', {
                parent: 'app',
                url: '/market-price/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/market-price/market-price-delete-dialog.html',
                        controller: 'MarketPriceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketPrice', function(MarketPrice) {
                                return MarketPrice.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('market-price', null, { reload: 'market-price' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
            $stickyStateProvider.enableDebug(true);
    }

})();
